/**
 * GroupRow Component
 * 그룹 테이블의 개별 행 (아코디언 방식)
 */
import React, { useCallback } from 'react';
import Loading from '@/shared/components/feedback/Loading';
import { CommonCodeGroup, CommonCodeItem } from '../types/commonCode.types';
import CodeTable from './CodeTable';
import { navigateToEditPage } from '../utils/commonCodeManagementUtils';
import { LOADING_MESSAGES } from '../constants/commonCode.constants';

interface GroupRowProps {
    group: CommonCodeGroup;
    isExpanded: boolean;
    isLoading: boolean;
    codes: CommonCodeItem[];
    onToggle: (grpCode: string) => void;
}

const GroupRow: React.FC<GroupRowProps> = ({
                                               group,
                                               isExpanded,
                                               isLoading,
                                               codes,
                                               onToggle,
                                           }) => {
    const handleEditClick = useCallback((e: React.MouseEvent) => {
        e.stopPropagation();
        navigateToEditPage(group.grpCode);
    }, [group.grpCode]);

    const handleRowClick = useCallback(() => {
        onToggle(group.grpCode);
    }, [group.grpCode, onToggle]);

    return (
        <React.Fragment>
            <tr
                className={`group-row ${isExpanded ? 'selected' : ''}`}
                onClick={handleRowClick}
            >
                <td className="code-cell clickable">
                    <span className="code-value">{group.grpCode}</span>
                </td>
                <td className="name-cell clickable">{group.grpName}</td>
                <td className="value-cell clickable">{group.grpVal}</td>
                <td className="action-cell">
                    <button
                        className="edit-group-button"
                        onClick={handleEditClick}
                        title="그룹 수정"
                    >
                        <i className="fas fa-edit"></i>
                    </button>
                </td>
                <td className="expand-indicator">
                    <i className={`fas fa-chevron-down ${isExpanded ? 'expanded' : ''}`}></i>
                </td>
            </tr>

            {isExpanded && (
                <tr className="group-codes-row">
                    <td colSpan={5} className="group-codes-cell">
                        {isLoading ? (
                            <div className="group-codes-loading">
                                <Loading message={LOADING_MESSAGES.CODES} />
                            </div>
                        ) : (
                            <CodeTable codes={codes} />
                        )}
                    </td>
                </tr>
            )}
        </React.Fragment>
    );
};

export default GroupRow;
